import type { TransactionDetail } from '../schemas/transactionDetail'
import { parseInstructionToTransfer } from './parseInstructionToTransfer'
import type { TokenAccountMap, TokenTransfer } from './types'

type CreateTokenTransfersParameters = {
  readonly transaction: TransactionDetail
  readonly tokenAccounts: TokenAccountMap
}

export const createTokenTransfers = ({
  transaction,
  tokenAccounts,
}: CreateTokenTransfersParameters): readonly TokenTransfer[] => {
  const mut_transfers: TokenTransfer[] = []

  // create transfer by instruction
  const innerInstructions = transaction.meta?.innerInstructions ?? []
  for (const [
    index,
    instruction,
  ] of transaction.transaction.message.instructions.entries()) {
    const transfer = parseInstructionToTransfer({
      index,
      innerIndex: undefined,
      instruction,
      transaction,
      tokenAccounts,
    })
    if (transfer !== undefined) {
      mut_transfers.push(transfer)
    }
    const innerInstruction = innerInstructions.find(
      (innerInstruction) => innerInstruction.index === index,
    )
    if (innerInstruction !== undefined) {
      for (const [
        innerIndex,
        instruction,
      ] of innerInstruction.instructions.entries()) {
        const transfer = parseInstructionToTransfer({
          index: innerInstruction.index,
          innerIndex,
          instruction,
          transaction,
          tokenAccounts,
        })
        if (transfer !== undefined) {
          mut_transfers.push(transfer)
        }
      }
    }
  }

  // create transfer by diff between postBalance and preBalance
  if (transaction.meta !== null) {
    for (const [
      index,
      accountKey,
    ] of transaction.transaction.message.accountKeys.entries()) {
      const address = accountKey.pubkey
      const inAmount = mut_transfers
        .filter(
          (transfer) => transfer.type === 'native' && transfer.to === address,
        )
        .reduce((accumulator, transfer) => accumulator + transfer.amount, 0n)
      const outAmount = mut_transfers
        .filter(
          (transfer) => transfer.type === 'native' && transfer.from === address,
        )
        .reduce((accumulator, transfer) => accumulator + transfer.amount, 0n)
      const txFeeAmount = index === 0 ? BigInt(transaction.meta.fee) : 0n
      const diff =
        BigInt(transaction.meta.postBalances[index]) -
        (BigInt(transaction.meta.preBalances[index]) +
          inAmount -
          outAmount -
          txFeeAmount)
      if (diff > 0) {
        mut_transfers.push({
          type: 'native',
          instructionIndex: undefined,
          innerInstructionIndex: undefined,
          from: undefined,
          to: address,
          amount: diff,
        })
      } else if (diff < 0) {
        mut_transfers.push({
          type: 'native',
          instructionIndex: undefined,
          innerInstructionIndex: undefined,
          from: address,
          to: undefined,
          amount: -1n * diff,
        })
      }
    }
  }

  // TODO 一時的にコメントアウト・不要説が濃厚
  // // create transfer by diff between postTokenBalance and preTokenBalance
  // const preTokenBalances = transaction.meta?.preTokenBalances ?? []
  // const postTokenBalances = transaction.meta?.postTokenBalances ?? []
  // const mintAddresses = new Set([
  //   ...preTokenBalances.map((tokenBalance) => tokenBalance.mint),
  //   ...postTokenBalances.map((tokenBalance) => tokenBalance.mint),
  // ])
  // for (const [
  //   index,
  //   accountKey,
  // ] of transaction.transaction.message.accountKeys.entries()) {
  //   const address = accountKey.pubkey
  //   for (const mint of mintAddresses) {
  //     const preBalance = preTokenBalances.find(
  //       (tokenBalance) =>
  //         tokenBalance.accountIndex === index && tokenBalance.mint === mint,
  //     )?.uiTokenAmount.amount
  //     const postBalance = postTokenBalances.find(
  //       (tokenBalance) =>
  //         tokenBalance.accountIndex === index && tokenBalance.mint === mint,
  //     )?.uiTokenAmount.amount
  //     if (preBalance === undefined && postBalance === undefined) {
  //       continue
  //     }
  //     const preBalanceBn = BigInt(preBalance ?? '0')
  //     const postBalanceBn = BigInt(postBalance ?? '0')
  //     const inAmount = mut_transfers
  //       .filter(
  //         (transfer) =>
  //           transfer.type === 'spl' &&
  //           transfer.token === mint &&
  //           transfer.to === address,
  //       )
  //       .reduce((accumulator, transfer) => accumulator + transfer.amount, 0n)
  //     const outAmount = mut_transfers
  //       .filter(
  //         (transfer) =>
  //           transfer.type === 'spl' &&
  //           transfer.token === mint &&
  //           transfer.from === address,
  //       )
  //       .reduce((accumulator, transfer) => accumulator + transfer.amount, 0n)
  //     const diff = postBalanceBn - (preBalanceBn + inAmount - outAmount)
  //     if (diff > 0) {
  //       mut_transfers.push({
  //         type: 'spl',
  //         instructionIndex: undefined,
  //         innerInstructionIndex: undefined,
  //         token: mint,
  //         from: undefined,
  //         to: address,
  //         amount: diff,
  //       })
  //     } else if (diff < 0) {
  //       mut_transfers.push({
  //         type: 'native',
  //         instructionIndex: undefined,
  //         innerInstructionIndex: undefined,
  //         from: address,
  //         to: undefined,
  //         amount: -1n * diff,
  //       })
  //     }
  //   }
  // }

  return mut_transfers
}
